// import Package from '../../package.json'
export const PackageName = 'moti';
//# sourceMappingURL=package-name.js.map